export class AccountSummaryRequest{
    center:string;
    month:number;
    year:number;
    constructor(center:string, month:number, year:number){
        this.center = center;
        this.month = month;
        this.year = year;
    }
}